// @flow

import { PureComponent } from 'react';
import styled, { keyframes } from 'styled-components';
import PropTypes from 'prop-types';

const LoaderContainer = styled.div`
  display: flex;
  font-size: 10px;
  padding: 5em 0;
`;

const brandLoaderAnimation = keyframes`
  0% {
    opacity: 0;
  }

  25% {
    opacity: 1;
  }

  50% {
    opacity: 1;
  }

  75% {
    opacity: 0;
  }

  100% {
    opacity: 0;
  }
`;

const Bar = styled.div`
  display: flex;
  opacity: 0;
  width: 2.3em;
  height: 7.2em;
  background-color: ${props => props.theme.brand};
  transform: rotateZ(30deg) skewY(-30deg);
  animation: 2s linear ${brandLoaderAnimation} infinite;
  animation-delay: 0.125s;
`;

const FirstBar = styled(Bar)`
  transform: rotateZ(30deg) translateY(-4.5em) skewY(-30deg);
  animation-delay: 0s;
`;

const SecondBar = styled(Bar)`
  margin-left: 1.5em;
`;

const ThirdBar = styled(Bar)`
  margin-left: 1.5em;
  transform: rotateZ(30deg) translateY(4.5em) skewY(-30deg);
  animation-delay: 0.25s;
`;

type Props = {
  style?: {}
};

class BrandLoader extends PureComponent<Props> {
  render() {
    return (
      <LoaderContainer style={{ ...this.props.style }}>
        <FirstBar />
        <SecondBar />
        <ThirdBar />
      </LoaderContainer>
    );
  }
}

BrandLoader.propTypes = {
  style: PropTypes.object
};

export default BrandLoader;
